<template>
    <div class="cz2__sb-animation" key="sbAnimation" :data-render-time="new Date().getTime()">
        <div ref="sb-animation-overlay" class="cz2__sb-animation__overlay" />

        <video v-if="sbAnimationVideoFile" ref="sb-animation-video" class="cz2__sb-animation__video" preload="auto" muted playsinline>
            <source :src="sbAnimationVideoFile" type="video/webm">
        </video>
    </div>
</template>

<style lang="scss">
    .cz2__sb-animation {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;

        background-color: transparent;

        pointer-events: none;

        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        z-index: 10000;
    }

    .cz2__sb-animation__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 200%;

        background: linear-gradient(to bottom, #1a75cf 0%, #1a75cf 50%, transparent 100%);

        opacity: 0;
        transform: translateY(0);

        transition: opacity 0.5s ease, transform 0.5s ease;

        z-index: 10001;
    }

    .cz2__sb-animation__video {
        width: 100%;
        height: 100%;

        object-fit: cover;
        opacity: 0;

        transition: opacity 0.25s ease;
        z-index: 10002;
    }
</style>

<script>
    export default {
        data() {
            return {
                sbAnimationVideoFile: null,
            };
        },

        computed: {
            haveSettings() {
                if (this.$store.state.options != null && this.$store.state.customizer.globalSettings != null) {
                    return this.$store.state.customizer.globalSettings;
                }

                return null;
            },
        },

        watch: {
            haveSettings(newValue) {
                if (newValue) {
                    this.checkSettings();
                }
            },
        },

        methods: {
            checkSettings() {
                let size = 'd';

                if (this.$store.state.options.isKiosk) {
                    size = 'k';
                } else if (window.innerWidth < 1024) {
                    size = 'm';
                } else {
                    size = 'd';
                }

                this.sbAnimationVideoFile = this.haveSettings.blueprint.custom[`fun-sb-transition-video-${size}`];
            },

            play(callback) {
                const overlay = this.$refs['sb-animation-overlay'];
                const video = this.$refs['sb-animation-video'];

                // Fade in the overlay.
                overlay.style.transition = 'opacity 0.25s ease-out';
                overlay.style.opacity = 1;
                overlay.style.transform = 'translateY(0%)';

                // After 0.25s, fade in the video and start playing it.
                setTimeout(() => {
                    // eslint-disable-next-line.
                    console.log('Start playing');

                    video.style.opacity = 1;
                    video.play();

                    // This is a good place to swap out the UX.
                    if (callback) {
                        callback();
                    }
                }, 250);

                // Failure check.
                this.fallbackTimer = setTimeout(() => {
                    // eslint-disable-next-line.
                    console.log('Fallback timer');

                    this.sbFadeOutOverlay(null, true);
                }, 3000);

                video.addEventListener('timeupdate', this.sbFadeOutOverlay);
                video.addEventListener('timeupdate', this.sbFadeOutVideo);
            },

            sbFadeOutOverlay(e, force) {
                const overlay = this.$refs['sb-animation-overlay'];
                const video = this.$refs['sb-animation-video'];

                const remainingTime = video.duration - video.currentTime;

                if (this.fallbackTimer) {
                    clearTimeout(this.fallbackTimer);
                }

                if (remainingTime <= 1.25 || force) {
                    overlay.style.transition = 'opacity 0.75s ease-out 0.5s, transform 1.25s ease-out';
                    overlay.style.opacity = 0;
                    overlay.style.transform = 'translateY(-50%)';

                    video.removeEventListener('timeupdate', this.sbFadeOutOverlay);
                }
            },

            sbFadeOutVideo() {
                const video = this.$refs['sb-animation-video'];

                const remainingTime = video.duration - video.currentTime;

                if (remainingTime <= 0.25) {
                    video.style.transition = 'opacity 0.25s ease-out';
                    video.style.opacity = 0;

                    video.removeEventListener('timeupdate', this.sbFadeOutVideo);

                    setTimeout(() => {
                        video.pause();
                        video.currentTime = 0;
                    }, 250);
                }
            },
        },
    };
</script>
